// extracted by mini-css-extract-plugin
export default {"editBtn":"CreateUser_editBtn__LlxWd"};